import React from "react";
import { MapPin } from "lucide-react";
import { CITIES } from "../mock";

const Cities = () => {
  return (
    <section className="py-16 md:py-20 px-5 md:px-8 bg-[#E7EDF3]">
      <div className="max-w-7xl mx-auto text-center fade-up">
        <span className="text-[12px] font-bold tracking-[0.16em] text-[#159A90] uppercase">
          Serving Across
        </span>
        <h2 className="font-heading font-extrabold text-[#1B2A4A] text-[30px] md:text-[40px] leading-tight mt-3">
          6 Cities in India
        </h2>
      </div>

      <div className="mt-12 flex flex-wrap justify-center gap-4">
        {CITIES.map((c) => (
          <div
            key={c}
            className="flex items-center gap-2.5 bg-white rounded-full pl-4 pr-6 py-3.5 border border-[#DEE6EE] shadow-[0_6px_18px_rgba(0,0,0,0.05)]"
          >
            <span className="flex items-center justify-center w-8 h-8 rounded-full bg-[#E7EDF3]">
              <MapPin size={16} className="text-[#159A90]" />
            </span>
            <span className="font-heading font-semibold text-[16px] text-[#1B2A4A]">
              {c}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Cities;
